export enum FormStatusEnum {
    New = 1,
    InProcess = 2,
    CompletedAwaitingApproval = 3,
    Cancelled = 4,
    Withdrawn = 5,
    Approved = 6,
    IsActive = New | InProcess | CompletedAwaitingApproval,
    Inactive = Cancelled | Withdrawn,
}
